import { render, staticRenderFns } from "./chatImage.vue?vue&type=template&id=44fc2830&scoped=true&"
import script from "./chatImage.vue?vue&type=script&lang=js&"
export * from "./chatImage.vue?vue&type=script&lang=js&"
import style0 from "./chatImage.vue?vue&type=style&index=0&id=44fc2830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc2830",
  null
  
)

export default component.exports